import { render } from "./QuestionnaireSideBar.vue?vue&type=template&id=053b4602&scoped=true"
import script from "./QuestionnaireSideBar.vue?vue&type=script&lang=js"
export * from "./QuestionnaireSideBar.vue?vue&type=script&lang=js"

import "./QuestionnaireSideBar.vue?vue&type=style&index=0&id=053b4602&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-053b4602"]])

export default __exports__